import { ApiCallback, unsafeCallApi } from './apiCaller';

import sleep from './sleep';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const sdkActions: ApiCallback<any>[] = [];

export const storeAction = <T>(cb: ApiCallback<T>): void => {
    sdkActions.push(cb);
};

export const runActions = async () => {
    for (const cb of sdkActions) {
        // TODO - Remove sleep after SDK fixes initialization issues
        await sleep(200);
        await unsafeCallApi(cb);
    }

    sdkActions.length = 0;
};
